import React, { ReactNode } from 'react';
import { useFeatureFlag } from '../contexts/FeatureFlagContext';
import { FeatureFlags } from '../config/featureFlags';

interface FeatureFlagProps {
  feature: keyof FeatureFlags;
  children: ReactNode;
  fallback?: ReactNode;
}

export const FeatureFlag: React.FC<FeatureFlagProps> = ({
  feature,
  children,
  fallback = null,
}) => {
  const isEnabled = useFeatureFlag(feature);
  
  return isEnabled ? <>{children}</> : <>{fallback}</>;
};

export default FeatureFlag;
